import script from "./OrdersIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrdersIndex.vue?vue&type=script&setup=true&lang=ts"

import "./OrdersIndex.vue?vue&type=style&index=0&id=4c0f8e11&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0f8e11"]])

export default __exports__